import React from 'react'
import { inject, observer } from 'mobx-react'
import CopyGeometryButton from 'components/common/tooltips/CopyGeometryButton'
import MoveGeometryButton from 'components/common/tooltips/MoveGeometryButton'
import DeleteItemPrompt from 'components/tools/item/DeleteItemPrompt'
import { withTranslation } from 'react-i18next'
import ExportKMZButton from 'components/common/tooltips/ExportKMZButton'
import ProBadge from 'components/common/ProBadge'
import { startProCheckout } from '../../../proCheckout'
import ColorButton from '../common/ColorButton'
import { HugeiconsIcon } from '@hugeicons/react'
import {
  CenterFocusIcon,
  FileSpreadsheetIcon,
  Delete02Icon
} from '@hugeicons/core-free-icons'

const OwnedBoundary = ({ boundary, group, uiStore, selectionStore, t }) => (
  <div className='owned-boundary'>
    <section className='owned-geopolygon__list'>
      <ColorButton item={boundary} />
      <button onClick={e => {
        e.currentTarget.blur()
        uiStore.setBoundsToItem(boundary)
      }}
      >
        <HugeiconsIcon icon={CenterFocusIcon} size={18} className='popup-menu__icon' />
        <span>{t('GLOBAL.FIT_REGION')}</span>
      </button>
      <CopyGeometryButton
        lgIcon
        group={group}
        onSubmit={() => uiStore.copyBoundary(boundary, group)}
      />
      <MoveGeometryButton
        lgIcon
        group={group}
        onSubmit={() => uiStore.moveBoundary(boundary, group)}
      />
      <button
        key='btn-excel'
        className={uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}
        onClick={(e) => {
          e.stopPropagation()
          if (uiStore.user && uiStore.user.type === 'starter') {
            startProCheckout({ uiStore, t })
            return
          }
          boundary.analysis.exportExcel(boundary.name)
        }}
      >
        <HugeiconsIcon icon={FileSpreadsheetIcon} size={18} className='popup-menu__icon' />
        <span>{t('GLOBAL.EXCEL_EXPORT')}</span>
        {uiStore.user && uiStore.user.type === 'starter' &&
          <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
      </button>
      <ExportKMZButton lgIcon item={boundary} />
      <button
        className='delete'
        onClick={(e) => {
          e.stopPropagation()
          uiStore.openDeletePrompt({
            style: {
              width: 340
            },
            position: 'right-start',
            selector: '.tools.popup-menu',
            text: (
              <DeleteItemPrompt
                item={group}
                itemType='boundary'
                title={t('GLOBAL.DELETE_BOUNDARY_Q', { defaultValue: 'Delete boundary?' })}
                itemName={boundary.name}
                description={t('GLOBAL.DELETE_BOUNDARY_DESC', { defaultValue: 'This boundary and its saved data will be permanently removed.' })}
                onSubmit={() => uiStore.deleteBoundary(group, boundary)}
              />
            )
          })
        }}
      >
        <HugeiconsIcon icon={Delete02Icon} size={18} className='popup-menu__icon' />
        <span>{t('GLOBAL.DELETE')}</span>
      </button>
    </section>
  </div>
)

export default withTranslation()(inject('uiStore', 'selectionStore')(observer(OwnedBoundary)))
